import template from './publishActions.template.html'
import controller from './publishActions.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    storyObj: '<',
    webskedObj: '<',
  },
  controller,
  controllerAs: 'vm',
}
